/**
 * Asynchronously loads the component for GuaranteeReportPage
 */

import { lazyLoad } from 'utils/loadable';

export const GuaranteeReportPage = lazyLoad(
  () => import('./index'),
  module => module.GuaranteeReportPage,
);
